import * as yup from 'yup';

const PASSWORD_MIN_LENGTH = 6;
const NAME_MAX_LENGTH = 30;

export const createGroupAdminSchema = yup.object({
  email: yup.string().email('Informe um e-mail válido').required('E-mail é obrigatório'),

  password: yup
    .string()
    .min(PASSWORD_MIN_LENGTH, `A senha deve ter no mínimo ${PASSWORD_MIN_LENGTH} caracteres`)
    .required('Senha é obrigatória'),

  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Senhas não coincidem')
    .required('Confirmação de senha é obrigatória'),

  name: yup
    .string()
    .trim()
    .max(NAME_MAX_LENGTH, `Máximo ${NAME_MAX_LENGTH} caracteres excedido.`)
    .required('Nome é obrigatório'),

  storeGroupIds: yup.array().of(yup.string()).min(1, 'Selecione ao menos um grupo'),
});
